import { Box, Container } from '@mui/material';
import { FC } from 'react';
import { ChildrenType } from '../../../../shared/lib/interfaceTypes';
import { DashboardHeader } from './DashboardHeader';
import { DashboardFooter } from './DashboardFooter';

export const DashboardContainer: FC<ChildrenType> = ({ children }) => (
  <Box display="flex" flexDirection="column" minHeight="100vh">
    <DashboardHeader />

    <Box component="main" flex="1 1 auto" overflow="auto" pb="40px">
      <Container maxWidth={false} sx={{ maxWidth: '1400px' }}>
        {children}
      </Container>
    </Box>

    <DashboardFooter />
  </Box>
);
